module.exports = __webpack_public_path__ + "static/media/delete-dustbin.bc99566d.svg";